module.exports = __webpack_public_path__ + "img/NedbankPay.a880be2f.png";